// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 336px) {
  .title2 {
    color: white;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  .mySwiper2 {
    display: flex;
    height: 400px;
  }
  .myswiper2 .swiper-coverflow {
    justify-content: center;
  }
  /* Make all slides slightly transparent */
  .mySwiper2 .swiper-slide {
    opacity: 0.6;
    transition: transform 0.8s, opacity 0.8s;
    transition-timing-function: ease-out;
  }
  /* .mySwiper2 .swiper-slide img {
    height: 450px;
  } */
  /* Make the active slide fully opaque */
  .mySwiper2 .swiper-slide-active {
    opacity: 1;
  }
}
@media (min-width: 337px) and (max-width: 976px) {
  .title2 {
    color: white;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  .mySwiper2 {
    display: flex;
    height: 400px;
  }
  .myswiper2 .swiper-coverflow {
    justify-content: center;
  }
  /* Make all slides slightly transparent */
  .mySwiper2 .swiper-slide {
    opacity: 0.6;
    transition: transform 0.8s, opacity 0.8s;
    transition-timing-function: ease-out;
  }
  /* .mySwiper2 .swiper-slide img {
    height: 450px;
  } */
  /* Make the active slide fully opaque */
  .mySwiper2 .swiper-slide-active {
    opacity: 1;
  }
}
@media (min-width: 977px) {
  .title2 {
    color: white;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  .mySwiper2 {
    display: flex;
    height: 500px;
  }
  .myswiper2 .swiper-coverflow {
    justify-content: center;
  }
  /* Make all slides slightly transparent */
  .mySwiper2 .swiper-slide {
    opacity: 0.6;
    transition: transform 0.8s, opacity 0.8s;
    transition-timing-function: ease-out;
  }
  /* .mySwiper2 .swiper-slide img {
    height: 450px;
  } */
  /* Make the active slide fully opaque */
  .mySwiper2 .swiper-slide-active {
    opacity: 1;
  }
}
/* Let recessed coverflow slides receive clicks through the wrapper plane. */
.mySwiper2 .swiper-wrapper {
  pointer-events: none;
}
.mySwiper2 .swiper-slide {
  pointer-events: auto;
}
.mySwiper2 .station-select {
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
}
.mySwiper2 .station-select img {
  display: block;
  width: 100%;
}
.mySwiper2 .station-select:focus-visible {
  outline: 3px solid #ffc107;
  outline-offset: -3px;
}
/*# sourceMappingURL=stationsStyle.css.map */`, "",{"version":3,"sources":["webpack://./stationsStyle.css","webpack://./client/Components/stationsStyle.css"],"names":[],"mappings":"AAAA;EACE;IACE,YAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;ECCF;EDEA;IACE,aAAA;IACA,aAAA;ECAF;EDGA;IACE,uBAAA;ECDF;EACA,yCAAyC;EDIzC;IACE,YAAA;IACA,wCAAA;IACA,oCAAA;ECFF;EACA;;KAEG;EACH,uCAAuC;EDMvC;IACE,UAAA;ECJF;AACF;ADOA;EACE;IACE,YAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;ECLF;EDQA;IACE,aAAA;IACA,aAAA;ECNF;EDSA;IACE,uBAAA;ECPF;EACA,yCAAyC;EDUzC;IACE,YAAA;IACA,wCAAA;IACA,oCAAA;ECRF;EACA;;KAEG;EACH,uCAAuC;EDYvC;IACE,UAAA;ECVF;AACF;ADaA;EACE;IACE,YAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;ECXF;EDcA;IACE,aAAA;IACA,aAAA;ECZF;EDeA;IACE,uBAAA;ECbF;EACA,yCAAyC;EDgBzC;IACE,YAAA;IACA,wCAAA;IACA,oCAAA;ECdF;EACA;;KAEG;EACH,uCAAuC;EDkBvC;IACE,UAAA;EChBF;AACF;AACA,4EAA4E;ADmB5E;EACE,oBAAA;ACjBF;ADoBA;EACE,oBAAA;AClBF;ADqBA;EACE,cAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;ACnBF;ADsBA;EACE,cAAA;EACA,WAAA;ACpBF;ADuBA;EACE,0BAAA;EACA,oBAAA;ACrBF;AACA,4CAA4C","sourcesContent":["@media (max-width: 336px) {\n  .title2 {\n    color: white;\n    font-size: 20px;\n    font-weight: bold;\n    text-align: center;\n  }\n\n  .mySwiper2 {\n    display: flex;\n    height: 400px;\n  }\n\n  .myswiper2 .swiper-coverflow {\n    justify-content: center;\n  }\n\n  /* Make all slides slightly transparent */\n  .mySwiper2 .swiper-slide {\n    opacity: 0.6;\n    transition: transform 0.8s, opacity 0.8s;\n    transition-timing-function: ease-out;\n  }\n\n  /* .mySwiper2 .swiper-slide img {\n    height: 450px;\n  } */\n\n  /* Make the active slide fully opaque */\n  .mySwiper2 .swiper-slide-active {\n    opacity: 1;\n  }\n}\n\n@media (min-width: 337px) and (max-width: 976px) {\n  .title2 {\n    color: white;\n    font-size: 20px;\n    font-weight: bold;\n    text-align: center;\n  }\n\n  .mySwiper2 {\n    display: flex;\n    height: 400px;\n  }\n\n  .myswiper2 .swiper-coverflow {\n    justify-content: center;\n  }\n\n  /* Make all slides slightly transparent */\n  .mySwiper2 .swiper-slide {\n    opacity: 0.6;\n    transition: transform 0.8s, opacity 0.8s;\n    transition-timing-function: ease-out;\n  }\n\n  /* .mySwiper2 .swiper-slide img {\n    height: 450px;\n  } */\n\n  /* Make the active slide fully opaque */\n  .mySwiper2 .swiper-slide-active {\n    opacity: 1;\n  }\n}\n\n@media (min-width: 977px) {\n  .title2 {\n    color: white;\n    font-size: 20px;\n    font-weight: bold;\n    text-align: center;\n  }\n\n  .mySwiper2 {\n    display: flex;\n    height: 500px;\n  }\n\n  .myswiper2 .swiper-coverflow {\n    justify-content: center;\n  }\n\n  /* Make all slides slightly transparent */\n  .mySwiper2 .swiper-slide {\n    opacity: 0.6;\n    transition: transform 0.8s, opacity 0.8s;\n    transition-timing-function: ease-out;\n  }\n\n  /* .mySwiper2 .swiper-slide img {\n    height: 450px;\n  } */\n\n  /* Make the active slide fully opaque */\n  .mySwiper2 .swiper-slide-active {\n    opacity: 1;\n  }\n}\n\n/* Let recessed coverflow slides receive clicks through the wrapper plane. */\n.mySwiper2 .swiper-wrapper {\n  pointer-events: none;\n}\n\n.mySwiper2 .swiper-slide {\n  pointer-events: auto;\n}\n\n.mySwiper2 .station-select {\n  display: block;\n  width: 100%;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n\n.mySwiper2 .station-select img {\n  display: block;\n  width: 100%;\n}\n\n.mySwiper2 .station-select:focus-visible {\n  outline: 3px solid #ffc107;\n  outline-offset: -3px;\n}\n","@media (max-width: 336px) {\n  .title2 {\n    color: white;\n    font-size: 20px;\n    font-weight: bold;\n    text-align: center;\n  }\n  .mySwiper2 {\n    display: flex;\n    height: 400px;\n  }\n  .myswiper2 .swiper-coverflow {\n    justify-content: center;\n  }\n  /* Make all slides slightly transparent */\n  .mySwiper2 .swiper-slide {\n    opacity: 0.6;\n    transition: transform 0.8s, opacity 0.8s;\n    transition-timing-function: ease-out;\n  }\n  /* .mySwiper2 .swiper-slide img {\n    height: 450px;\n  } */\n  /* Make the active slide fully opaque */\n  .mySwiper2 .swiper-slide-active {\n    opacity: 1;\n  }\n}\n@media (min-width: 337px) and (max-width: 976px) {\n  .title2 {\n    color: white;\n    font-size: 20px;\n    font-weight: bold;\n    text-align: center;\n  }\n  .mySwiper2 {\n    display: flex;\n    height: 400px;\n  }\n  .myswiper2 .swiper-coverflow {\n    justify-content: center;\n  }\n  /* Make all slides slightly transparent */\n  .mySwiper2 .swiper-slide {\n    opacity: 0.6;\n    transition: transform 0.8s, opacity 0.8s;\n    transition-timing-function: ease-out;\n  }\n  /* .mySwiper2 .swiper-slide img {\n    height: 450px;\n  } */\n  /* Make the active slide fully opaque */\n  .mySwiper2 .swiper-slide-active {\n    opacity: 1;\n  }\n}\n@media (min-width: 977px) {\n  .title2 {\n    color: white;\n    font-size: 20px;\n    font-weight: bold;\n    text-align: center;\n  }\n  .mySwiper2 {\n    display: flex;\n    height: 500px;\n  }\n  .myswiper2 .swiper-coverflow {\n    justify-content: center;\n  }\n  /* Make all slides slightly transparent */\n  .mySwiper2 .swiper-slide {\n    opacity: 0.6;\n    transition: transform 0.8s, opacity 0.8s;\n    transition-timing-function: ease-out;\n  }\n  /* .mySwiper2 .swiper-slide img {\n    height: 450px;\n  } */\n  /* Make the active slide fully opaque */\n  .mySwiper2 .swiper-slide-active {\n    opacity: 1;\n  }\n}\n/* Let recessed coverflow slides receive clicks through the wrapper plane. */\n.mySwiper2 .swiper-wrapper {\n  pointer-events: none;\n}\n.mySwiper2 .swiper-slide {\n  pointer-events: auto;\n}\n.mySwiper2 .station-select {\n  display: block;\n  width: 100%;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n.mySwiper2 .station-select img {\n  display: block;\n  width: 100%;\n}\n.mySwiper2 .station-select:focus-visible {\n  outline: 3px solid #ffc107;\n  outline-offset: -3px;\n}\n/*# sourceMappingURL=stationsStyle.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
